// src/stockx/line/SearchIcon.ts
import { createIcon } from "@chakra-ui/icons";
var SearchIcon = createIcon({
  displayName: "SearchIcon",
  viewBox: "0 0 50 50",
  d: "M33.8 31.5L32.5 31.6C34.9 29 36.4 25.5 36.4 21.7C36.4 13.7 29.9 7.10001 21.8 7.10001C13.7 7.10001 7.3 13.7 7.3 21.7C7.3 29.7 13.8 36.3 21.9 36.3C25.6 36.3 29 34.9 31.5 32.6L31.4 34L40.3 42.9L42.7 40.5L33.8 31.5ZM21.9 33.3C15.5 33.3 10.3 28.1 10.3 21.7C10.3 15.3 15.5 10.1 21.9 10.1C28.3 10.1 33.5 15.3 33.5 21.7C33.5 28.1 28.2 33.3 21.9 33.3Z"
});
var SearchIcon_default = SearchIcon;

export {
  SearchIcon_default
};
